import { ca } from '@cian/analytics';
import { ESalesType } from '../../types/offersData';

const SALES_TYPE_ANALYTICS = new Map<ESalesType, string>([
  [ESalesType.PromoIndexPage, 'to_promo'],
  [ESalesType.SalesLeader, 'SalesLeaders'],
  [ESalesType.SalesStart, 'SalesStart'],
  [ESalesType.UpcomingSale, 'SalesSoon'],
]);

export function trackSalesLinkClick(salesType: ESalesType): void {
  const gaLabel = SALES_TYPE_ANALYTICS.get(salesType);

  ca('eventSite', {
    action: 'Click',
    category: 'ListingJK',
    label: gaLabel,
    name: 'oldevent',
  });
}
